import { render } from "./Edit.vue?vue&type=template&id=2e9af2b0"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__